export const apiConfig = {
  // Api Key para conexión
  header: {
    'Content-Type': 'application/json',
    'x-api-key': 'L8vDTV7wJMa6s8BGCsbC8uL7cFGu08DybuQnkwAKjpULZDpFcShAoOOv31Bf',
  },
  company: 11,
  baseUrl: 'https://eanx.co/api/',
  mercadoPago: {
    returnUrl: 'http://prospective-agency.eastus.cloudapp.azure.com/cuenta-creada',
  },
};
